import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import 'animate.css';
import "./src/styles/global.css";
import "tw-elements";

export const onClientEntry = () => {
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = "https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap";
  document.head.appendChild(link);
};
